import { lazy, Suspense, Children } from 'react';
import { useMediaQuery } from '../../utilities/hooks';

const OwlCarousel = lazy(() => import(/* webpackChunkName: "owl-carousel" */ './OwlCarouselWithJquery'));

// Mientras llega el carrusel se muestran las primeras diapositivas con la misma disposición
// (items por fila y separación), para que el contenido de abajo no salte.
const Placeholder = ({ className, items, margin, children }) => (
    <div className={className} style={{ display: 'flex', gap: margin, overflow: 'hidden' }}>
        {Children.toArray(children)
            .slice(0, items)
            .map((child, i) => (
                <div key={i} style={{ flex: `0 0 calc((100% - ${(items - 1) * margin}px) / ${items})` }}>
                    {child}
                </div>
            ))}
    </div>
);

// Carrusel Owl que solo existe por debajo de `hideFrom` (los de la Home llevan d-lg-none:
// en escritorio estaban ocultos pero igual se descargaba e inicializaba jQuery + Owl).
// Owl crea los puntos de navegación como <button> sin texto: se les da un nombre accesible.
const labelDots = event => {
    const root = event && event.target;
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.owl-dot').forEach((dot, i) => dot.setAttribute('aria-label', `Go to slide ${i + 1}`));
};

const LazyOwlCarousel = ({ hideFrom = 'lg', onInitialized, onRefreshed, ...props }) => {
    const hidden = useMediaQuery(hideFrom);
    if (hidden) return null;
    return (
        <Suspense fallback={<Placeholder {...props} />}>
            <OwlCarousel
                {...props}
                onInitialized={e => (labelDots(e), onInitialized && onInitialized(e))}
                onRefreshed={e => (labelDots(e), onRefreshed && onRefreshed(e))}
            />
        </Suspense>
    );
};

export default LazyOwlCarousel;
